import { render } from "./PageCallAction.vue?vue&type=template&id=64be013c"
import script from "./PageCallAction.vue?vue&type=script&lang=js"
export * from "./PageCallAction.vue?vue&type=script&lang=js"

import "./PageCallAction.vue?vue&type=style&index=0&id=64be013c&lang=css"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Sub4Turismo\\FrontSite\\CodigoVueSub4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__